import type H from 'history';

import type { Account } from '@feathr/blackbox';

export function assertActivePackage(
  activePackage: Account['activePackage'] | undefined,
  isInternal: boolean,
  history: H.History,
  localUrl: (url: string) => string,
): asserts activePackage is NonNullable<Account['activePackage']> {
  if (isInternal) {
    return;
  }

  if (!activePackage && !isInternal) {
    history.push(localUrl('/settings/billing'));
  }
}
